import './App.css';

import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { useEffect, useState } from 'react';

import AboutPage from './pages/AboutPage';
import AgeVerificationOverlay from './components/AgeVerificationOverlay';
import ContactPage from './pages/ContactPage';
import { DNA } from 'react-loader-spinner';
import GamesPage from './pages/GamesPage';
import Header from './components/Navigation';
import HomePage from './pages/HomePage';
import PrivacyPage from './pages/PrivacyPage';
import { ROUTES } from './Routes';
import ResponsiblePage from './pages/ResponsiblePage';
import ScrollToTop from './components/ScrollToTop';
import TermsPage from './pages/TermPage';

const App = () => {
  const [ageVerified, setAgeVerified] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return (
      <div style={{ margin: 0, padding: 0, height: '100%', overflow: 'hidden' }}>
        <DNA
          visible={true}
          height="80"
          width="80"
          ariaLabel="dna-loading"
          wrapperStyle={{ position: 'absolute', top: 0, right: 0, height: '100%', width: '100%', border: 'none' }}
          wrapperClass="dna-wrapper"
        />
      </div>
    );
  }

  return (
    <>
      {!ageVerified && (
        <AgeVerificationOverlay onConfirm={() => setAgeVerified(true)} />
      )}
      <Router>
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path={ROUTES.BASE} element={<HomePage />} />
          <Route path={ROUTES.ABOUT} element={<AboutPage />} />
          <Route path={ROUTES.CONTACT} element={<ContactPage />} />
          <Route path={ROUTES.GAMES} element={<GamesPage />} />
          <Route path={ROUTES.PRIVACY} element={<PrivacyPage />} />
          <Route path={ROUTES.TERMS} element={<TermsPage />} />
          <Route path={ROUTES.RESPONSIBLE} element={<ResponsiblePage />} />
        </Routes>
      </Router>
    </>
  );
};

export default App;